"use client"

/**
 * Last-resort boundary: catches errors thrown by the root layout itself, which
 * every other error.tsx sits inside of and therefore cannot catch. Before this
 * existed, a root-layout crash rendered Next's default blank error page and was
 * reported nowhere.
 *
 * This file REPLACES the root layout when it fires — globals.css never loads,
 * so Tailwind classes would be inert here. Styles are inline on purpose.
 */

import { useReportError } from "@/lib/posthog-client"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useReportError(error)

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fafaf9",
          color: "#1c1917",
          fontFamily:
            "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        }}
      >
        <div style={{ maxWidth: "28rem", padding: "1.5rem", textAlign: "center" }}>
          <h1 style={{ fontSize: "1.125rem", fontWeight: 600, margin: 0 }}>
            The app failed to load
          </h1>
          <p style={{ marginTop: "0.5rem", fontSize: "0.875rem", color: "#57534e" }}>
            Something broke before the page could render. Reloading usually fixes it — if it
            doesn&apos;t, send an admin the reference below.
          </p>
          {error.digest && (
            <p
              style={{
                marginTop: "0.5rem",
                fontSize: "0.75rem",
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                color: "#a8a29e",
              }}
            >
              Ref: {error.digest}
            </p>
          )}
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: "1.5rem",
              border: "none",
              borderRadius: "0.375rem",
              background: "#1c1917",
              color: "#fff",
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
